import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// Actions
import { uiLocations } from '../constants/analytics';
import {
  toggleDriveModal as toggleDriveModalAction,
  toggleErrorDriveModal as toggleErrorDriveModalAction
} from '../current/uiwidgets';
import { cleanupCreateUi } from 'current/uiwidgets/screen-transition';

// Selectors
import { isActiveFieldLoading, isInitialLoadDone } from 'api/loading/selectors';
import { isAppMode as isAppModeFunc } from 'settings/selectors';

// Util
import { getCreateRoute } from 'util/routes';

// Components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import ManageBody from 'manage/ManageBody';
import DeleteModalContainer from 'common/modals/DeleteModalContainer';
import DuplicateModalContainer from 'common/modals/DuplicateModalContainer';
import RenameModalContainer from 'common/modals/RenameModalContainer';
import SetPrimaryModalContainer from 'common/modals/SetPrimaryModalContainer';
import SelectAffiliateOrganizationModalContainer from 'common/modals/SelectAffiliateOrganizationModalContainer';
import ConnectToAffiliateModalContainer from 'common/modals/ConnectToAffiliateModalContainer';
import DriveModalConnected from '../common/modals/DriveModal';
import DriveModalError from '../common/modals/DriveModalError';
import CreateJDWorkingPlanModal from 'common/modals/CreateJDWorkingPlanModal';

import { trackAction } from 'util/analytics';
import BackToTableView from '../common/BackToTableView';
import PreferredDeviceModal from 'common/modals/PreferredDeviceModal';

const baseString = 'vra-manage';
class ManageContainer extends Component {

  componentDidMount() {
    // Handle changes that may have happened in create/edit to create a fresh state for
    // the create/edit screens.
    this.props.handleCleanupCreateUi();
  }

  render() {
    const {
      initialLoadIsInProgress,
      isActiveFieldLoading,
      isAppMode,
      isDriveModalActive,
      isErrorDriveModalActive,
      linkToCreateRoute,
      onClickCreatePrescriptionTrigger,
      toggleDriveModal,
      toggleErrorDriveModal,
      isCreateJDWorkPlanOpen
    } = this.props;
    const classString = classNames({
      [`${baseString}`]: true,
      'vra-route-container': true,
      'vra-route-container--manage': true,
      'vra-route-container--app-mode': isAppMode
    });

    return (
      <LoadingWrapperContainer initialLoadIsInProgress={initialLoadIsInProgress}>
        <BackToTableView />
        <div className={classString} data-test-id={'manage-all-script-types'}>
          <ManageBody
            isActiveFieldLoading={isActiveFieldLoading}
            linkToCreateRoute={linkToCreateRoute}
            onClickCreatePrescriptionTrigger={onClickCreatePrescriptionTrigger}
          />
          <DeleteModalContainer/>
          <DuplicateModalContainer/>
          <RenameModalContainer/>
          <SetPrimaryModalContainer/>
          <SelectAffiliateOrganizationModalContainer/>
          <PreferredDeviceModal/>
          <ConnectToAffiliateModalContainer uiLocation={uiLocations.MANAGE}/>
          <CreateJDWorkingPlanModal isModalOpen={isCreateJDWorkPlanOpen}/>
          <DriveModalConnected open={isDriveModalActive} toggleDriveModal={toggleDriveModal}/>
          <DriveModalError open={isErrorDriveModalActive} toggleErrorDriveModal={toggleErrorDriveModal}/>
        </div>
      </LoadingWrapperContainer>
    );
  }
}

ManageContainer.propTypes = {
  handleCleanupCreateUi: propTypes.func,
  initialLoadIsInProgress: propTypes.bool.isRequired,
  isActiveFieldLoading: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isDriveModalActive: propTypes.bool.isRequired,
  isErrorDriveModalActive: propTypes.bool.isRequired,
  linkToCreateRoute: propTypes.string,
  onClickCreatePrescriptionTrigger: propTypes.func,
  toggleDriveModal: propTypes.func.isRequired,
  toggleErrorDriveModal: propTypes.func.isRequired,
  isCreateJDWorkPlanOpen: propTypes.bool.isRequired
};

export default connect(
  (state) => {
    return {
      isActiveFieldLoading: isActiveFieldLoading(state),
      isAppMode: isAppModeFunc(state),
      isDriveModalActive: state.uiwidgets.isDriveModalActive,
      isErrorDriveModalActive: state.uiwidgets.isErrorDriveModalActive,
      initialLoadIsInProgress: !isInitialLoadDone(state),
      linkToCreateRoute: getCreateRoute(state),
      isCreateJDWorkPlanOpen: state.uiwidgets.isCreateWorkPlanModalOpen
    };
  },
  (dispatch) => {
    return {
      onClickCreatePrescriptionTrigger: () => {
        trackAction('Clicked on Create new Prescription');
        return;
      },
      handleCleanupCreateUi: () => dispatch(cleanupCreateUi()),
      toggleDriveModal: (value) => dispatch(toggleDriveModalAction(value)),
      toggleErrorDriveModal: (value) => dispatch(toggleErrorDriveModalAction(value))
    };
  }
)(ManageContainer);
